(function () {
  const motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  const reducedMotion = () => !!(motionQuery && motionQuery.matches);

  function initSlider(root) {
    if (root.dataset.kyInitialized === 'true') return;
    root.dataset.kyInitialized = 'true';
    const slides = Array.from(root.querySelectorAll('[data-ky-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-ky-dot]'));
    if (!slides.length) return;

    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer = null;
    let pointerStart = null;
    let suppressClick = false;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function stop() {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    }
    function start() {
      stop();
      if (slides.length > 1 && !reducedMotion() && root.dataset.autoplay === 'true' && !document.hidden) {
        timer = window.setInterval(() => show(index + 1), 6200);
      }
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) start(); });
    root.addEventListener('click', event => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    root.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse') pointerStart = event.clientX;
    }, { passive: true });
    root.addEventListener('pointerup', event => {
      if (pointerStart === null) return;
      const delta = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(delta) > 45) {
        suppressClick = true;
        show(index + (delta < 0 ? 1 : -1));
        start();
        window.setTimeout(() => { suppressClick = false; }, 350);
      }
    }, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    if (motionQuery && motionQuery.addEventListener) motionQuery.addEventListener('change', start);
    show(index);
    start();
  }

  function initProductCarousels() {
    document.querySelectorAll('.ky-product-category-row').forEach(row => {
      const track = row.querySelector('[data-ky-product-carousel]');
      if (!track || track.dataset.kyScrollReady === 'true') return;
      track.dataset.kyScrollReady = 'true';
      row.querySelectorAll('[data-ky-scroll]').forEach(button => {
        button.addEventListener('click', () => {
          const card = track.querySelector('.ky-product-card');
          const gap = 15;
          const amount = card ? card.getBoundingClientRect().width + gap : 260;
          track.scrollBy({ left: (button.dataset.kyScroll === 'next' ? 1 : -1) * amount * 2, behavior: reducedMotion() ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ky-slider]').forEach(initSlider);
    initProductCarousels();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
